<template>
  <div>

    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <!-- Breadcrumb -->
      <app-breadcrumb>
        <template #contentright>
          <b-button
            v-if="$route.params.id !== undefined"
            variant="success"
            :to="{ name: 'mobile-vehicle-add' }"
          >
            <span class="text-nowrap">
              <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }}
            </span>
          </b-button>
          <span v-else />
        </template>
      </app-breadcrumb>
      <b-row>
        <b-col md="12">
          <b-card aria-hidden="true">
            <!-- Alert: No item found -->
            <b-alert
              variant="danger"
              :show="errorMessage !== ''"
            >
              <h4 class="alert-heading">
                {{ errorMessage }}
              </h4>

            </b-alert>

            <!-- BODY -->
            <validation-observer
              #default="{ handleSubmit }"
              ref="refFormObserver"
            >
              <!-- Form -->
              <b-form
                class=""
                @submit.prevent="handleSubmit(onSubmit)"
                @reset.prevent="resetForm"
              >
                <b-row>
                  <b-col md="12">

                    <!-- Name -->
                    <validation-provider
                      #default="validationContext"
                      :name="$t('Tên xe')"
                      rules="required"
                    >
                      <b-form-group>
                        <template #label>
                          <label class="d-block font-weight-bolder">Tên xe <span class="text-danger">*</span></label>
                        </template>
                        <b-form-input
                          id="name"
                          v-model="itemData.name"
                          :state="getValidationState(validationContext)"
                        />

                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                  </b-col>

                  <b-col md="6">
                    <b-form-group label-for="code">
                      <template #label>
                        <label class="d-block font-weight-bolder">Mã hiệu</label>
                      </template>
                      <b-form-input
                        id="name"
                        v-model="itemData.code"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <validation-provider
                      #default="validationContext"
                      :name="$t('Hãng sản xuất')"
                      rules="required"
                    >
                      <b-form-group label-for="manufacture_id">
                        <template #label>
                          <label class="d-block font-weight-bolder">Hãng sản xuất <span class="text-danger">*</span></label>
                        </template>
                        <v-select
                          v-model="itemData.manufacture_id"
                          :options="dataManufacture"
                          :reduce="val => val.id"
                          label="name"
                          placeholder="--Chọn--"
                        />
                        <b-form-invalid-feedback :state="getValidationState(validationContext)">
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="6">
                    <b-form-group label-for="note">
                      <template #label>
                        <label class="d-block font-weight-bolder">Ghi chú</label>
                      </template>
                      <b-form-input
                        id="note"
                        v-model="itemData.note"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <validation-provider
                      #default="validationContext"
                      :name="$t('Trạng thái')"
                      rules="required"
                    >
                      <b-form-group label-for="manager_id">
                        <template #label>
                          <label class="d-block font-weight-bolder">Trạng thái <span class="text-danger">*</span></label>
                        </template>
                        <v-select
                          v-model="itemData.status"
                          :options="statusOptions"
                          :reduce="val => val.id"
                          label="name"
                          placeholder="--Chọn--"
                        />
                        <b-form-invalid-feedback :state="getValidationState(validationContext)">
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>

                <hr class="mt-2">
                <div class="col-12  justify-content-between d-flex">

                  <label
                    for=""
                    class="d-block font-weight-bolder"
                  >Danh sách thiết bị</label>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-info"
                    class="mb-2"
                    type="button"
                    @click="showDevice()"
                  >
                    <feather-icon icon="PlusCircleIcon" /> Thêm thiết bị
                  </b-button>
                </div>
                <div class="col-4 mb-1">
                  <b-input-group>
                    <b-form-input
                      v-model="localSearch"
                      class="d-inline-block "
                      placeholder="Nhập tên thiết bị"
                      @keydown.enter.prevent="doSearch"
                    />
                    <b-input-group-append>
                      <span
                        class="btn btn-primary"
                        @click="doSearch"
                      >
                        <feather-icon icon="SearchIcon" />
                      </span>
                    </b-input-group-append>
                  </b-input-group>
                </div>
                <table class="table table-rep">
                  <thead>
                    <tr>
                      <th>
                        Tên thiết bị
                      </th>
                      <th>Series</th>
                      <th class="text-center">
                        Hành động
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item) in items"
                      :key="item.device_id + forceUpdate"
                    >
                      <td>{{ item.device_name }}</td>
                      <td>{{ convertArrayToString(item.seriIds) }}</td>
                      <td class="text-center">
                        <b-button
                          class="btn btn-icon mr-1 btn-sm   btn-warning"
                          @click="editDevice(item, itemData.id)"
                        >
                          <span class="text-nowrap">
                            <feather-icon icon="EditIcon" />
                          </span>
                        </b-button>
                        <b-button
                          class="btn btn-icon btn-sm  btn-danger"
                          @click="handlRemoveDevice(item)"
                        >
                          <span class="text-nowrap">
                            <feather-icon icon="Trash2Icon" />
                          </span>
                        </b-button>
                      </td>
                    </tr>

                  </tbody>
                </table>
                <!-- Form Actions -->
                <div class="d-flex mt-2">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mr-2"
                    type="submit"
                  >
                    {{ $t('Save') }}
                  </b-button>
                </div>

              </b-form>
            </validation-observer>
          </b-card>

        </b-col>
      </b-row>
    </b-overlay>
    <b-modal
      id="formSearchDevice"
      body-class=" mb-2"
      size="lg"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      hide-footer
      title="Thiết bị"
    >
      <form-search-device
        :devices="items"
        @updateDevice="handleDevice"
        @resetData="handleDialog"
      />
    </b-modal>
    <b-modal
      id="formEditDevice"
      body-class=" mb-2"
      size="lg"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      hide-footer
      title="Thay đổi series"
    >
      <form-edit-device-series
        :device="itemDevice"
        :mobile-vehicle-id="mobileVehicleId"
        @resetData="handleDialogEditDevice"
        @updateDevice="handleDevice"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BAlert, BOverlay, BForm, BFormGroup, BButton, BFormInput, BFormInvalidFeedback,
  BFormTags, BTooltip, BInputGroupAppend, BFormTag, BInputGroup,
} from 'bootstrap-vue'
import { tStr } from 'validation_t/src'
import {
  ref, watch,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter, showToast } from '@core/utils/utils';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, alphaNum, alphaNumDot, max, integer, positive,
} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'

import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import vSelect from 'vue-select'
import FormSearchDevice from './FormSearchDevice.vue';
import FormEditDeviceSeries from './FormEditDeviceSeries.vue';

function formatPrice(val) {
  const price = val.toString().replace(/,/g, '');
  return price;
}
export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BAlert,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    BFormTags,
    BTooltip,
    BInputGroupAppend,
    BInputGroup,
    BFormTag,
    vSelect,
    flatPickr,
    FormSearchDevice,
    FormEditDeviceSeries,
    tStr,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      integer,
      alphaNum,
      alphaNumDot,
      max,
      positive,
      devices: [],
      itemDevice: [],
      mobileVehicleId: integer,
      forceUpdate: 0,

    }
  },
  watch: {
  },
  methods: {
    showDevice() {
      this.$bvModal.show('formSearchDevice')
    },
    handleDevice(data) {
      let indexOldData = 0;
      if (this.dataDeviceOriginal !== null) {
        indexOldData = this.items.findIndex(t => t.device_id === data.device_id);
        if (+indexOldData > -1 && data.seriIds.length > 0) {
          this.dataDeviceOriginal.splice(indexOldData, 1, data);
        } else if (data.seriIds.length > 0) {
          this.dataDeviceOriginal.push(data);
        }
      } else {
        this.dataDeviceOriginal.push(data);
      }
      this.items = this.dataDeviceOriginal
      this.$bvModal.hide('formSearchDevice')
      this.$bvModal.hide('formEditDevice')
    },
    handlRemoveDevice(data) {
      const item = this.dataDeviceOriginal.filter(t => t.device_id !== data.device_id);
      this.items = item;
      this.itemRemoves.push(data);
      this.dataDeviceOriginal = item
    },
    editDevice(item, mobileVehicleId) {
      this.itemDevice = item
      this.mobileVehicleId = mobileVehicleId
      this.items = this.dataDeviceOriginal
      this.$bvModal.show('formEditDevice');
    },
    jsonCopy(_data) {
      return JSON.parse(JSON.stringify(_data));
    },
    handleDialog() {
      this.$bvModal.hide('formSearchDevice')
    },
    handleDialogEditDevice() {
      this.$bvModal.hide('formEditDevice')
    },
    convertArrayToString(items) {
      return items.map(o => o.name).join(',')
    },
    doSearch() {
      if (this.localSearch !== '') {
        const dataSearch = this.dataDeviceOriginal.filter((o) => {
          const fName = o.device_name;
          const byQuery = this.localSearch
            ? String(tStr.removeAscent(fName))
              .toLowerCase()
              .replaceAll(' ', '')
              .includes(
                String(tStr.removeAscent(this.localSearch))
                  .toLowerCase()
                  .replaceAll(' ', ''),
              )
            : true;
          return byQuery;
        });
        this.items = dataSearch
      } else {
        this.items = this.dataDeviceOriginal
      }
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const layout = ref(route.value.name !== 'devices-edit' ? 'add' : 'edit');
    // const loading = ref(!!id.value)
    const loading = ref(true)
    const errorMessage = ref('')
    // const devices = ref([])
    const dataCountry = ref([])
    const dataManufacture = ref([])
    const dataCategoryTypeDevice = ref([])
    const dataProvider = ref([])
    const dataModel = ref([])
    const dataDepartment = ref([])
    const items = ref([])
    const dataDeviceOriginal = ref([])
    const itemRemoves = ref([])
    const dataUser = ref([])
    const seriesName = ref([])
    const dataForms = ref([])
    const localSearch = ref('')
    const statusOptions = [
      { name: 'Tốt', id: 10 },
      { name: 'Hỏng', id: 20 },
      { name: 'Đang sửa', id: 30 },
      { name: 'Đang bảo dưỡng', id: 40 },
    ];
    const defaultItemData = {
      id: null,
      name: '',
      status: 10,
      department_id: null,
      manager_id: null,
      note: '',
    }
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)))

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)

    store.dispatch('mobileVehicle/fetchOne', { id: router.currentRoute.params.id })
      .then(response => {
        if (response.status === 200) {
          itemData.value = response.data.data
          dataForms.value = itemData.value.data_fields
          items.value = itemData.value.data_devices ? itemData.value.data_devices : []
          dataDeviceOriginal.value = itemData.value.data_devices ? itemData.value.data_devices : []
          loading.value = false
        }
      })

    const onSubmit = () => {
      errorMessage.value = '';
      // loading.value = true;
      itemData.value.data_fields = dataForms.value;
      // itemData.value.items = items.value;
      itemData.value.items = dataDeviceOriginal.value;
      itemData.value.dataDeviceOriginal = dataDeviceOriginal.value; // gốc
      itemData.value.itemRemoves = itemRemoves.value;
      store.dispatch('mobileVehicle/update', { data: itemData.value, id: itemData.value.id })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.code === 200) {
              showToast(response.data.message, { variant: 'success' });
              resetForm()
              // emit('updateData')
              router.push({ name: 'mobile-vehicle-list' })
            } else {
              showToast(response.data.message)
              errorMessage.value = response.data.message;
            }
          }
        })
    }
    const fetchManufacture = () => {
      store.dispatch('manufacturer/fetchAll', {
        type: 20,
      })
        .then(response => {
          if (response.data.code === 200) {
            dataManufacture.value = response.data.data;
          }
        })
    }
    fetchManufacture();

    const fetchData = () => {
      loading.value = true;
      store.dispatch('device/fetchOne', { id: id.value })
        .then(response => {
          if (response.status === 200) {
            itemData.value = response.data.data
            // convertCurrency();
            seriesName.value = itemData.value.series.map(o => o.name);
            // seriesName.value = itemData.value.series.map(o => ({
            //   name: o.name,
            //   id: o.id,
            // }));

            loading.value = false
            errorMessage.value = '';
          } else {
            errorMessage.value = response.message
            loading.value = false
          }
        })
    }
    const configDate = ref({
      dateFormat: 'd-m-Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });

    return {
      id,
      layout,
      errorMessage,
      loading,
      itemData,
      // devices,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
      fetchData,
      dataCountry,
      dataManufacture,
      dataCategoryTypeDevice,
      dataProvider,
      dataModel,
      dataDepartment,
      dataUser,
      configDate,
      // convertCurrency,
      seriesName,
      statusOptions,
      dataForms,
      items,
      itemRemoves,
      localSearch,
      dataDeviceOriginal,
    }
  },

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
